export const NONE = 1;
export const PARTIAL = 2;
export const FULL = 3;



// WEBPACK FOOTER //
// ./js/constants/FavouriteState.js